// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__BqS3J"};